if (!customElements.get('finder-package-toggler')) {  
  customElements.define(
    'finder-package-toggler',
    class FinderPackageToggler extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        window.addEventListener('click', e => {
          const clickedEl = e.target.closest('[data-finder-package-toggler-action]');
          if (!clickedEl) return;
          const action = clickedEl.dataset.finderPackageTogglerAction;
          if (action) {
            if (clickedEl.hasAttribute('data-scroll-to')) {
              this.scrollIntoView({ behavior: "smooth" });
            }

            this.querySelector(`[data-finder-package-toggler-action=${action}]`)?.click();
            this.classList.remove('details', 'nutrition');
            this.classList.add(action);
          }
          
        })
      }
    }
  );
}